import { ArrayField, FunctionField, Labeled } from 'react-admin';
import { Card, Typography } from '@mui/material';

import ResourceGrid from '../../../../components/ResourceGrid';
import SimpleTableLayout from '../../../../components/SimpleTableLayout';
import { customerBillingStyle } from './CustomerBillingStyle';

export default function CardDetails({ paymentDetails }) {
  const classes = customerBillingStyle();
  const record = {
    payment_details: [paymentDetails],
  };

  const labelStyle = {
    '& .RaLabeled-label': { fontSize: '12px', marginBottom: '12px' },
  };
  const fontStyle = {
    fontWeight: '400',
    fontSize: '14px',
  };

  return paymentDetails ? (
    <Card className={classes.billingDetailsCard} variant=''>
      <ResourceGrid record={record}>
        <ArrayField source='payment_details' label=''>
          <SimpleTableLayout
            className={classes.tableSize}
            labelClassName={classes.label}
            title={`Test`}
          >
            <Labeled sx={labelStyle} label='CARD'>
              <FunctionField
                style={fontStyle}
                render={(record = {}) => {
                  return (
                    <>
                      <div className={classes.cardDetails}>
                        <Typography
                          style={{
                            fontSize: '14px',
                            fontWeight: '400',
                            textTransform: 'capitalize',
                          }}
                        >
                          {record.payment_details.brand}
                        </Typography>
                        <Typography style={{ fontSize: '14px', fontWeight: '400' }}>
                          {' '}
                          ending in {record.payment_details.last4}
                        </Typography>
                      </div>
                      <Typography style={{ fontSize: '14px', fontWeight: '400' }}>
                        {record.payment_details.funding}
                      </Typography>
                    </>
                  );
                }}
              />
            </Labeled>

            <Labeled sx={labelStyle} label='EXP'>
              <FunctionField
                style={fontStyle}
                render={(record = {}) => {
                  return (
                    <Typography style={{ fontSize: '14px', fontWeight: '400' }}>
                      {record.payment_details.exp_month}/
                      {record.payment_details.exp_year}
                    </Typography>
                  );
                }}
              />
            </Labeled>
          </SimpleTableLayout>
        </ArrayField>
      </ResourceGrid>
    </Card>
  ) : null;
}
